<template>
  <!-- Loading spinner when isLoading is true -->
  <div
    v-if="isLoading"
    class="d-flex justify-content-center align-items-center"
    style="height: 40vh"
  >
    <div class="custom-spinner" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>

  <!-- Error Handling -->
  <div v-if="!isLoading && errorMessage.length > 0" class="alert alert-danger">
    <strong>Erro!</strong> {{ errorMessage }}
  </div>

  <!-- Company Form component when isLoading is false -->
  <div v-if="!isLoading">
    <company-form
      @save-data="saveData"
      @change-final-check="changeFinalCheck"
      :showFinalCheck="showFinalCheck"
    ></company-form>
  </div>
</template>

<script>
// import child component
import CompanyForm from '@/components/register/CompanyForm.vue';
export default {
  components: {
    CompanyForm,
  },
  data() {
    return {
      isLoading: false, // Sets the Loading Spinner On and Off
      errorMessage: '', // Error message to display to the user
      showFinalCheck: false, // controls display of the final check
      buttonPressed: false, // to check if user pressed the register button and store it in the state
    };
  },
  methods: {
    // child component emits to call this method that hides/shows the final check pop-up
    changeFinalCheck() {
      this.showFinalCheck = !this.showFinalCheck;
    },

    // method to send the company data to backend
    async saveData(data) {
      // commit the data to the state
      this.$store.commit('register/setCompanyData', data);

      // Set the Loading Spinner On
      this.setLoading(true);

      // dispatch the action to send the data to the backend
      var resultMessage = await this.$store.dispatch(
        'register/registerCompany',
        data
      );

      // Set the Loading Spinner Off
      this.setLoading(false);

      // Check if the company information was saved successfully
      // if there was an error display it
      if (resultMessage.error) {
        resultMessage =
          'Erro ao guardar a informação da empresa. Por favor tente novamente.';
        this.errorHandling(resultMessage);

        // if the company already exists in the database with the same nif and with an answered survey
      } else if (resultMessage.exists) {
        this.showFinalCheck = true; // show the pop up to confirm user wants to store the data and fill the survey again

        // if the data was successfully saved save the returning company_id in the local storage
      } else {
        const companyInfo =
          JSON.parse(localStorage.getItem('companyInformation')) || {};
        companyInfo['Company_Id'] = resultMessage.id;
        localStorage.setItem('companyInformation', JSON.stringify(companyInfo));

        // and redirect to the survey page
        await this.$store.dispatch('register/setButtonPressed', true);
        this.$router.replace('/survey');
      }
    },

    // method to control the isLoading value
    setLoading(value) {
      this.isLoading = value;
    },

    // method to receive error messages and display them
    errorHandling(error) {
      this.errorMessage = error;
      if (this.errorMessage.length > 0) {
        //Scroll to the top of the page
        window.scrollTo({
          top: 0,
          behavior: 'smooth', // Scroll behavior
        });
      }
    },
  },
};
</script>
